export default __webpack_public_path__ + "static/media/responsive.12bf9e47.png";